export const formatDate = value => {
  const [day, month, year] = value.split('/');
  return `${year}-${month}-${day}`;
};
export const formatReverseDate = value => {
  if (!value) {
    return '';
  }
  const year = value.substring(0, 4);
  const month = value.substring(4, 6);
  const day = value.substring(6);

  return `${year}-${month}-${day}`;
};
export const dateToStringFormat = value => {
  if (value === '') {
    return value;
  }
  return value
    .replace(/\D/g, '')
    .replace(/(0){6}/g, '')
    .replace(/(\d{4})(\d{2})(\d{2})/g, '$3/$2/$1');
};

export const emptyIfNull = value => value || '';

export const currencyTagFormat = value => value.toFixed(2).replace(/\./g, ',');

export const capitalizeFirst = value =>
  `${value.charAt(0).toUpperCase()}${value.toLowerCase().substr(1)}`;

export const undefinedIfEmpty = value => (value === '' ? undefined : value);

export const formatCivilState = code =>
  ({
    '1': { codigo: 'S', valor: 'Solteiro' },
    '2': { codigo: 'C', valor: 'Casado' },
    '3': { codigo: 'D', valor: 'Divorciado' },
    '4': { codigo: 'J', valor: 'Separado Judicialmente' },
    '5': { codigo: 'V', valor: 'Viúvo' },
    default: { codigo: '', valor: '' },
  }[code]);
